import React from "react";
import { View, Text, Image } from "react-native";
import { AppColors } from "../../../../../../utility/AppColors";
import { AppImages } from "../../../../../../utility/AppImages";

interface LikesHeaderProps {
  likes: number;
  totalViewers: number;
  viewerDetails: Array<{ userId: string; profilePicture?: string }>;
}

const LikesHeader: React.FC<LikesHeaderProps> = ({
  likes = 0,
  totalViewers = 0,
  viewerDetails = [],
}) => {
  return (
    <View
      style={{
        flexDirection: "row",
        justifyContent: "space-between",
        height: "100%",
        alignItems: "center",
      }}
    >
      {/* Likes */}
      <View
        style={{
          flexDirection: "row",
          alignItems: "center",
          gap: 6,
        }}
      >
        <Text style={{ color: "white", fontSize: 12, opacity: 0.7 }}>
          Likes
        </Text>
        <Text style={{ color: "white", fontSize: 16, fontWeight: "600" }}>
          {likes}
        </Text>
      </View>

      {/* Divider */}
      <View
        style={{
          width: 1,
          height: 24,
          backgroundColor: "rgba(255, 255, 255, 0.2)",
        }}
      />

      {/* Total Viewers */}
      <View
        style={{
          flexDirection: "column",
          alignItems: "center",
          gap: 4,
        }}
      >
        <View
          style={{
            flexDirection: "row",
            alignItems: "center",
            gap: 6,
          }}
        >
          <Text style={{ color: "white", fontSize: 12, opacity: 0.7 }}>
            Total Viewers:
          </Text>
          <Text style={{ color: "white", fontSize: 16, fontWeight: "600" }}>
            {totalViewers}
          </Text>
        </View>
        {viewerDetails.length > 0 && (
          <View style={{ flexDirection: "row" }}>
            {(() => {
              const unique = [
                ...new Map(
                  viewerDetails.map((d: any) => [d.userId, d])
                ).values(),
              ].slice(0, 7);
              return unique.map((details: any, index: number) => (
                <View
                  key={details.userId}
                  style={{
                    width: 18,
                    height: 18,
                    backgroundColor: AppColors.white,
                    borderRadius: 9,
                    overflow: "hidden",
                    marginLeft: index > 0 ? -6 : 0,
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <Image
                    source={
                      details.profilePicture
                        ? { uri: details.profilePicture }
                        : AppImages.Ellipse1
                    }
                    style={{
                      width: 18,
                      height: 18,
                    }}
                    resizeMode="cover"
                  />
                </View>
              ));
            })()}
          </View>
        )}
      </View>
    </View>
  );
};

export default LikesHeader;
